<sm-item-list-item
  [item]="item"
  [loadGalleryImages]="loadGalleryImages"
  [imageLongPressEnabled]="true"
  [searchQuery]="searchQuery"
  [menuItems]="menuItems"
  [emptyDescriptionLabel]="emptyDescriptionLabel"
  [menuAriaLabel]="menuAriaLabel"
  (open)="handleOpen()"
  (menuItemSelect)="handleMenuItemSelect($event)">
</sm-item-list-item>

@if (result.tags?.length) { <p class="search-result-tags">@for (tag of result.tags; track tag.id) { <span>{{ tag.name }} · {{ tag.authorName }}</span> }</p> }
